import { Injectable } from '@angular/core';
import {
    INDDFormsI18nServiceConfigResources,
    NDDFormsI18nService,
} from '@shared/ndd-ng-forms/shared/ndd-ng-forms-i18n.service';

import { NDDIntlService } from 'ndd-ng-intl';
import { NDDTranslationService } from '@ndk/ng-translation';

/** Serviço de gerenciamento de erros dos controles do formulário. */
@Injectable()
export class NDDFormErrorService {
    /** Identificação de necessidade de tradução, conforme serviço i18n. */
    public resourcesI18n: boolean;
    /** Resources, conforme serviço i18n. */
    private resources: INDDFormsI18nServiceConfigResources;

    constructor(private intl: NDDIntlService, private translation: NDDTranslationService, private formsI18nService: NDDFormsI18nService) {
        this.resourcesI18n = this.formsI18nService.config.i18n;
        this.resources = this.formsI18nService.config.resources;
    }

    /**
     * Cria mensagem de erro, conforme erro gerado.
     *
     * @param {*} error Objeto de erro.
     * @returns {string} Mensagem de erro.
     * @memberof NDDFormErrorService
     */
    public message(error: any): string {
        let msg: string;
        let detail: string;

        // Define mensagem e detalhes de validação a serem exibidos, por tipo de erro.
        if (error.required) {
            msg = this.resources.invalidRequired;
        } else if (error.maxlength) {
            msg = this.resources.invalidMaxLength;
            detail = error.maxlength.requiredLength.toString();
        } else if (error.minlength) {
            msg = this.resources.invalidMinLength;
            detail = error.minlength.requiredLength.toString();
        } else if (error.max) {
            msg = this.resources.invalidMax;
            detail = error.max.max.toString();
        } else if (error.min) {
            msg = this.resources.invalidMin;
            detail = error.min.min.toString();
        } else if (error.minError && error.minError.minValue instanceof Date) { // Kendo
            msg = this.resources.invalidMinDate;
            detail = this.intl.formatDate(error.minError.minValue, 'd');
        } else if (error.maxError && error.maxError.maxValue instanceof Date) { // Kendo
            msg = this.resources.invalidMaxDate;
            detail = this.intl.formatDate(error.maxError.maxValue, 'd');
        } else if (error.timeRangeError) { // Kendo
            msg = this.resources.invalidTimeRange;
            detail = `${ this.intl.formatDate(error.timeRangeError.minValue, 'T') } - ${ this.intl.formatDate(error.timeRangeError.maxValue, 'T') }`;
        } else if (error.maxDecimalDigits) {
            msg = this.resources.invalidMaxDecimalDigits;
            detail = error.maxDecimalDigits.max.toString();
        } else if (error.minDecimalDigits) {
            msg = this.resources.invalidMinDecimalDigits;
            detail = error.minDecimalDigits.min.toString();
        } else if (error.pattern) {
            msg = this.resources.invalidPattern;
        } else if (error.email) {
            msg = this.resources.invalidEmail;
        } else if (error.customMessage) {
            msg = error.customMessage;
        }

        // Define mensagem completa a ser exibida.
        if (this.resourcesI18n) {
            msg = msg
                ? this.translation.instant(msg) + (detail ? ` (${ detail })` : '')
                : this.translation.instant(this.resources.invalidDefault);
        } else {
            msg = msg
                ? msg + (detail ? ` (${ detail })` : '')
                : this.resources.invalidDefault;
        }

        return msg;
    }
}
